<template>
	<b-row align-h="center">
		<b-col style="max-width: 1140px;">
			<div v-if="loading">Ladataan...</div>
			<template v-else>
				<div v-if="!idIsValid">
					Käyttäjäluonnoksen linkki ei valitettavasti ole voimassa.
				</div>
				<div v-else class="view-lomake">
					<b-card class="container header">
						<div class="logo">
							<b-img :src="cPicture" class="mb-4" />
						</div>
						<div class="header-text">
							{{
								!isNullOrEmpty(headerFooterData.headerFi)
									? headerFooterData.headerFi
									: "Uuden CRM-käyttäjäluonnoksen luonti."
							}}
						</div>
					</b-card>
					<b-card class="container">
						<div class="row">
							<div class="col-lg-6 info-column">
								<div class="form-group">
									<label for="fname">Etunimi <span style="color:red">*</span></label>
									<input
										type="text"
										id="fname"
										v-model.trim="user.fname"
										class="form-control"
										@blur="generateCalendarName()"
									/>
								</div>

								<div class="form-group">
									<label for="lname">Sukunimi <span style="color:red">*</span></label>
									<input
										type="text"
										id="lname"
										v-model.trim="user.lname"
										class="form-control"
										@blur="generateCalendarName()"
									/>
								</div>

								<div class="form-group">
									<label for="email">Sähköposti <span style="color:red">*</span></label>
									<input
										type="email"
										id="email"
										v-model.trim="user.email"
										class="form-control"
										@blur="copyEmailAsUsername()"
									/>
								</div>

								<div class="form-group">
									<label for="username"
										>Käyttäjätunnus <span style="color:red">*</span></label
									>
									<input
										type="text"
										id="username"
										v-model.trim="user.username"
										class="form-control"
									/>
								</div>

								<template v-if="calendarInUse">
									<div class="form-group">
										<label for="calendarName">Kalenterinimi</label>
										<input
											type="text"
											id="calendarName"
											v-model.trim="user.calendarName"
											class="form-control"
										/>
									</div>
								</template>
							</div>

							<div class="col-lg-6 info-column">
								<div class="form-group">
									<label for="title">Titteli</label>
									<input
										type="text"
										id="title"
										v-model.trim="user.title"
										class="form-control"
									/>
								</div>

								<div class="form-group">
									<label for="address">Postiosoite</label>
									<input
										type="text"
										id="address"
										v-model.trim="user.address"
										class="form-control"
									/>
								</div>

								<div class="form-group">
									<label for="postCode">Postinumero</label>
									<input
										type="text"
										id="postCode"
										v-model.trim="user.postCode"
										class="form-control"
									/>
								</div>

								<div class="form-group">
									<label for="postOffice">Postitoimipaikka</label>
									<input
										type="text"
										id="postOffice"
										v-model.trim="user.postOffice"
										class="form-control"
									/>
								</div>

								<div class="form-group">
									<label for="phone">Puhelinnumero</label>
									<input
										type="text"
										id="phone"
										v-model.trim="user.phone"
										class="form-control"
									/>
								</div>

								<div class="form-group">
									<label for="altEmail">Vaihtoehtoinen sähköposti</label>
									<input
										type="email"
										id="altEmail"
										v-model.trim="user.altEmail"
										class="form-control"
									/>
								</div>
							</div>
						</div>
					</b-card>

					<b-card class="permission-card">
						<div class="footer-text">
							{{ headerFooterData.footerFi }}
						</div>
						<div class="permissions">
							<div class="permissions-title">Lupa tietojen käsittelemiseen</div>
							<div class="form-group">
								<label class="form-check-label" for="general-permission">
									Hyväksyn, että tietoni tallennetaan organisaation
									{{ cOrgName }} asiakastietojärjestelmään
								</label>
								<br />
								<input
									type="checkbox"
									id="general-permission"
									class="form-check-inline"
									v-model="generalPermission"
								/>
								<label for="general-permission" class="text-muted">pakollinen</label>
							</div>
							<div
								class="form-group"
								v-for="(doc, index) in privacyPolicyDocs"
								:key="doc.uid"
							>
								<label class="form-check-label" :for="'privacy-permission' + index">
									Tutustu dokumenttiin:
									<a :href="getExternalUrl(doc.url)" target="_blank">{{ doc.name }}</a>
									<br />
									Olen lukenut ja hyväksyn dokumentin sisällön.
								</label>
								<br />
								<input
									type="checkbox"
									:id="'privacy-permission' + index"
									class="form-check-inline"
									v-model="doc.checked"
								/>
								<label :for="'privacy-permission' + index" class="text-muted"
									>pakollinen</label
								>
							</div>
						</div>
					</b-card>

					<div class="buttons">
						<button class="btn btn-primary save" @click="save">Lähetä</button>
						<button class="btn btn-outline-danger clear" @click="clearFields">
							Tyhjennä
						</button>
					</div>
				</div>
			</template>
		</b-col>
	</b-row>
</template>

<script>
import Vue from "vue";
import axios from "axios";

export default {
	name: "UserTemplateForm",

	components: {},

	data() {
		return {
			idCode: "",
			idIsValid: false,
			loading: true,
			orgData: {
				fullName: "",
				logoUrl: ""
			},
			user: {
				email: "",
				fname: "",
				lname: "",
				username: "",
				calendarName: "",
				title: "",
				address: "",
				postCode: "",
				postOffice: "",
				phone: "",
				altEmail: ""
			},
			calendarInUse: true,
			generalPermission: false,
			headerFooterData: {
				langFi: true,
				langSv: true,
				langEn: true,
				orgName: "",
				headerFi: "",
				headerSv: "",
				headerEn: "",
				picture: "",
				footerFi: "",
				footerSv: "",
				footerEn: ""
			},
			privacyPolicyDocs: []
		};
	},

	computed: {
		cPicture() {
			if (this.headerFooterData && this.headerFooterData.picture) {
				return this.headerFooterData.picture;
			} else {
				return this.orgData.logoUrl;
			}
		},

		cOrgName() {
			return !this.isNullOrEmpty(this.headerFooterData.orgName)
				? this.headerFooterData.orgName
				: this.orgData.fullName;
		}
	},

	beforeMount() {
		this.getOrgData();
		this.getHeaderFooterData("user-template");
		this.getPrivacyPolicyDocs();
	},

	watch: {
		$route: {
			handler(to) {
				if (to.params.org) {
					axios.defaults.headers.common["Organization"] = to.params.org;
				}

				if (to.params.code) {
					this.idCode = to.params.code;
				}
			},
			immediate: true,
			deep: true
		},

		idCode: {
			handler(val) {
				this.checkIdIsValid(val);
			},
			immediate: true
		}
	},

	methods: {
		getHeaderFooterData(docCode) {
			axios.get(`HeaderFooter/${docCode}`).then(resp => {
				if (resp.data) {
					this.headerFooterData.langFi = resp.data.langFi;
					this.headerFooterData.langSv = resp.data.langSv;
					this.headerFooterData.langEn = resp.data.langEn;
					this.headerFooterData.orgName = resp.data.orgName;
					this.headerFooterData.headerFi = resp.data.headerFi;
					this.headerFooterData.headerSv = resp.data.headerSv;
					this.headerFooterData.headerEn = resp.data.headerEn;
					this.headerFooterData.picture = resp.data.picture;
					this.headerFooterData.logoPath = resp.data.logoPath;
					this.headerFooterData.footerFi = resp.data.footerFi;
					this.headerFooterData.footerSv = resp.data.footerSv;
					this.headerFooterData.footerEn = resp.data.footerEn;
				}
			});
		},

		getOrgData() {
			axios.get("UserForm/orgData").then(resp => {
				if (resp.data) {
					this.orgData = resp.data;
				}
			});
		},

		getPrivacyPolicyDocs() {
			axios.get("UserForm/privacyPolicyDocs").then(resp => {
				if (resp.data) {
					this.privacyPolicyDocs = resp.data;
					this.privacyPolicyDocs.forEach(doc => {
						Vue.set(doc, "checked", false);
					});
				}
			});
		},

		save() {
			if (this.checkFieldsValidity()) {
				let payload = {
					draftCode: this.idCode,
					fname: this.user.fname ? this.user.fname : null,
					lname: this.user.lname ? this.user.lname : null,
					email: this.user.email ? this.user.email : null,
					username: this.user.username ? this.user.username : null,
					calendarName: this.user.calendarName ? this.user.calendarName : null,
					title: this.user.title ? this.user.title : null,
					address: this.user.address ? this.user.address : null,
					postCode: this.user.postCode ? this.user.postCode : null,
					postOffice: this.user.postOffice ? this.user.postOffice : null,
					phone: this.user.phone ? this.user.phone : null,
					altEmail: this.user.altEmail ? this.user.altEmail : null
				};

				// eslint-disable-next-line
				axios.post(`UserForm/save/`, payload)
					.then(() => {
						this.clearFields();
						this.$router.push({
							name: "ThankYou",
							params: "fi"
						});
					})
					.catch(err => {
						console.log(err.response);
						if (err.response.data?.detail) {
							alert(err.response.data.detail);
						} else {
							alert("Virhe luonnoksen tallennuksessa.");
						}
					});
			}
		},

		checkFieldsValidity() {
			if (this.user.fname.length < 1) {
				alert("Tarkista etunimi!");
				document.getElementById("fname").focus();
			} else if (this.user.lname.length < 1) {
				alert("Tarkista sukunimi!");
				document.getElementById("lname").focus();
			} else if (this.user.email.length < 1) {
				alert("Tarkista sähköposti!");
				document.getElementById("email").focus();
			} else if (this.user.username.length < 1) {
				alert("Tarkista käyttäjätunnus!");
				document.getElementById("username").focus();
			} else if (!this.generalPermission) {
				alert("Sinun täytyy hyväksyä tietojen käsittely jatkaaksesi.");
				document.getElementById("permission").focus();
			} else if (this.privacyPolicyDocs.some(doc => !doc.checked)) {
				alert("Sinun täytyy hyväksyä kaikki tietosuojadokumentit jatkaaksesi.");
				document.getElementById("privacy-permission0").focus();
			} else return true;
		},

		copyEmailAsUsername() {
			this.user.username = this.user.username ? this.user.username : this.user.email;
		},

		generateCalendarName() {
			if (this.user.fname && this.user.lname && !this.user.calendarName)
				this.user.calendarName = this.user.fname + this.user.lname.substring(0, 3);
		},

		clearFields() {
			this.user = {
				email: "",
				fname: "",
				lname: "",
				username: "",
				calendarName: "",
				title: "",
				address: "",
				postCode: "",
				postOffice: "",
				phone: "",
				altEmail: ""
			};
			this.permission = false;
		},

		checkIdIsValid(code) {
			this.loading = true;
			axios.get(`UserForm/code/${code}`).then(resp => {
				this.idIsValid = resp.data;
				this.loading = false;
			});
		},

		isNullOrEmpty(variable) {
			if (variable === null || typeof variable === "undefined" || variable.length == 0) {
				return true;
			}
			return false;
		},

		getExternalUrl(url) {
			if (!url) {
				return "";
			}
			let split = url.split("://");
			if (split.length > 1) {
				return "http://" + split[1];
			} else {
				return "http://" + split[0];
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.view-lomake {
	margin-top: 25px;
	margin-bottom: 25px;
}

.radio-inline {
	margin: 5px;
}

.permission-card,
.header {
	margin: 0.5rem 0;
}

.buttons {
	display: flex;
	align-content: space-between;

	button {
		width: 48%;
	}

	button.clear {
		margin-left: auto;
	}
}

div.logo {
	max-width: 70%;

	img {
		height: 4rem;
		width: auto;
		object-fit: contain;
	}
}
</style>
